// @ts-nocheck

import { StudyCompanyHistory } from '../types/study-companies';
import { StudyHistoryPacket } from '../types/studies';

interface ChartDataPoint {
  x: any;
  y: number;
}
function transformData(input: any[], key: string): ChartDataPoint[] {
  const sorted = [...input].sort((a, b) => {
    const yearA = a.year || a.display_year;
    const yearB = b.year || b.display_year;
    return yearA - yearB;
  });

  return sorted.map(item => ({
    x: item.year || item.display_year,
    y: item[key],
  }));
}

const makePeerSeries = (peers: StudyHistoryPacket[]) => {
  const colors = ['#ff9800', '#014421', '#673147', '#800020', '#000080', '#004852', '#8B3103'];
  return peers.map((peer, index) => {
    return {
      id: peer.name,
      label: peer.name,
      color: colors[index],
      data: transformData(peer.data, 'revenue'),
    };
  });
};

export { transformData, makePeerSeries };
